export const FORMATION_DETAIL_STICKY_COLUMNS = [
  { index: 1, width: 12 },
  { index: 2, width: 6 },
];
